module.exports = __webpack_public_path__ + "img/汉熵智慧园林管理平台.7be766c4.png";